<!--意见反馈-->
<template>
  <div class="feedback">
      <div class="feedback-title">请选择反馈类型</div>
      <div class="feedback-content">
        <div
          class="feedback-content-item"
          v-for="(item, index) in feedbackLists"
          :key="index"
          @click="enterPage(item, index)"
        >
          <div class="feedback-content-item-title">{{ item.title }}</div>
          <div class="feedback-content-item-desc">{{ item.desc }}</div>
          <div class="feedback-content-item-arrow"></div>
        </div>
      </div>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
const PAGE_TYPE = 'ZZUP_HELPCENTER_FEEDBACK'

export default {
  name: 'HelpCenterFeedback',
  data() {
    return {
      feedbackLists: [
        {
          title: '投诉中心',
          desc: '订单交易问题、退货退款、账户钱款等问题',
          jumpUrl: 'https://feentry.zhuanzhuan.com/athena?clientid=ComplaintCente'
        },
        {
          title: '违规申诉',
          desc: '账号封禁、商品下架等问题申诉',
          jumpUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html?type=idea#/helpcenter/AccountAppeal'
        },
        {
          title: '使用建议',
          desc: '用的不爽？我有建议',
          jumpUrl:
              'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html?type=idea#/helpcenter/InterFeedback'
        },
        {
          title: '功能异常',
          desc: '现有功能无法正常使用',
          jumpUrl:
              'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html?type=bugs#/helpcenter/InterFeedback'
        }
      ]
    }
  },
  components: {
    //
  },
  created() {
    native.setTitle({ title: '意见反馈' })
    lego.send({
      pagetype: PAGE_TYPE,
      actiontype: 'PAGE_SHOW'
    })
  },
  mounted() {
    //
  },
  methods: {
    enterPage(data, index) {
      lego.send({
        pagetype: PAGE_TYPE,
        actiontype: 'ENTER_CLICK',
        backup: {
          index,
          title: data.title
        }
      })
      native.skipToUrl({
        targetUrl: data.jumpUrl
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .feedback {
    position: absolute;
    width: 100%;
    height: 100%;
    background: white;
    padding: 0 32px;
    box-sizing: border-box;
    /*background: white;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*box-sizing: border-box;*/
    &-title {
      margin: 32px 0 0 0;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #999999;
    }
    &-content {
      &-item {
        margin: 20px 0 0 0;
        width: 686px;
        height: 154px;
        background: #f8f8f8;
        border-radius: 16px;
        border-radius: 16px;
        position: relative;
        &-title {
          position: absolute;
          top: 32px;
          left: 32px;
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #111111;
        }
        &-desc {
          position: absolute;
          bottom: 32px;
          left: 32px;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #999999;
        }
        &-arrow {
          position: absolute;
          top: 64px;
          right: 32px;
          width: 26px;
          height: 26px;
          background: url('https://pic2.zhuanstatic.com/zhuanzh/n_v202a6169431c3443587f2fce427ac7d6a.png')
            no-repeat;
          background-size: contain;
          background-position: center;
        }
      }
    }
  }
</style>
